import { Component, ViewEncapsulation, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { ApSwitchComponent } from '@ap/switch';

@Component({
    selector: 'ap-list-item-switch',
    templateUrl: './list-item-switch.html',
    styleUrls: ['./list-item-switch.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApSwitchComponent, ReactiveFormsModule]
})
export class ApListItemSwitchComponent {
    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     */
    public readonly itemClicked = output<void>();

    /**
     * In combination with the actionType `switch` this will show the switch and hold the boolean
     */
    public readonly switchControl = input<null | FormControl<boolean>>();

    public readonly disabled = input(false);

    protected readonly tabindex = input(-1);

    /**
     * the value of the list item
     */
    public readonly value = input<string>();

    protected onItemClicked(): void {
        this.itemClicked.emit(undefined);
        const switchControl = this.switchControl();
        if (switchControl?.disabled || this.disabled()) {
            return;
        }
        switchControl.markAsDirty();
        switchControl.markAsTouched();
        switchControl.setValue(!switchControl.value);
    }

    /**
     * Stop propagation from checkbox because it already sets the correct checkbox state
     * The switch is namely type="checkbox"
     * Stopping propagation prevents the switch to be called
     */
    public stopPropagation(event: Event): void {
        event.stopPropagation();
    }
}
